import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Téléphone — combiné duotone */
export const PhoneIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Combiné rempli menthe */}
      <path
        d="M5 3.5h3.5l2 5-2.5 1.5a11 11 0 0 0 6 6l1.5-2.5 5 2v3.5A2.5 2.5 0 0 1 17.5 21C9.5 21 3 14.5 3 6.5A2.5 2.5 0 0 1 5 3.5z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.6"
      />
      {/* Contour */}
      <path
        d="M5 3.5h3.5l2 5-2.5 1.5a11 11 0 0 0 6 6l1.5-2.5 5 2v3.5A2.5 2.5 0 0 1 17.5 21C9.5 21 3 14.5 3 6.5A2.5 2.5 0 0 1 5 3.5z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
PhoneIcon.displayName = "PhoneIcon";
